import { motion, AnimatePresence } from "framer-motion";
import { AppIcon } from "./AppIcon";
import { APPS } from "../data/apps";

export const FolderOverlay = ({ open, onClose, onOpenApp }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="folder-overlay"
          className="absolute inset-0 z-40 flex flex-col items-center justify-center px-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.28 }}
        >
          <motion.div
            className="absolute inset-0 bg-[#03112a]/70 backdrop-blur-2xl"
            onClick={onClose}
            data-testid="folder-backdrop"
          />

          <motion.div
            layoutId="eyb-folder"
            className="relative w-full max-w-[340px] rounded-[34px] border border-white/15 bg-white/10 p-7 backdrop-blur-3xl"
            style={{ boxShadow: "0 30px 80px rgba(0,0,0,0.5)" }}
            transition={{ type: "spring", stiffness: 200, damping: 26 }}
          >
            <div className="mb-6 text-center">
              <p className="text-[10px] uppercase tracking-[0.35em] text-white/50">
                EYB
              </p>
              <h3 className="font-heading text-xl font-semibold text-white">
                Your Apps
              </h3>
            </div>

            <div className="grid grid-cols-2 gap-5">
              {APPS.map((app, i) => (
                <AppIcon key={app.id} app={app} index={i} onOpen={onOpenApp} />
              ))}
            </div>
          </motion.div>

          <motion.button
            type="button"
            data-testid="folder-close-btn"
            onClick={onClose}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="relative mt-8 rounded-full border border-white/20 bg-white/10 px-6 py-2 text-sm font-medium text-white/80 backdrop-blur-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
          >
            Close
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
